/**
 * LoadingPage —— 全屏加载占位。
 *
 * 用在 Suspense fallback 和首屏会话校验中。组合 @novel-isr/ui 的 Spinner，
 * 套一层带 admin theme 颜色的容器，避免每个 fallback 各画各的。
 */
import { Spinner } from "@novel-isr/ui";
import styles from "./LoadingPage.module.scss";

export interface LoadingPageProps {
  /** 副标题，不传时只显示 spinner */
  label?: string;
  /** 紧凑模式 —— 只占一个内容区，不占满视口（路由切换时用） */
  compact?: boolean;
}

export function LoadingPage({ label = "正在加载...", compact = false }: LoadingPageProps) {
  return (
    <div
      className={compact ? styles.compact : styles.page}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Spinner size="lg" colorScheme="brand" aria-hidden="true" />
      {label && <p className={styles.label}>{label}</p>}
    </div>
  );
}
